<div class="main-card mb-3 card">
  <div class="card-body">
    <div class="title-block mb-3">
      <i class="fa fa-fw" [title]="'TR_GOBACK' | translate" (click)="mainService.goBack('content')"></i>
      <h5 class="card-title">{{ isCreateForm ? ('TR_CREATE_PAGE_CONTENT' | translate) : ('TR_UPDATE_PAGE_CONTENT' | translate) }}</h5>
    </div>
    <form (submit)="submitData()" [formGroup]="form">
      <div class="wrap-flex form-outline">
        <div *ngIf="page_view" ngbDropdown>
          <div class="flex flex-column">
            <label>{{ ('TR_PAGE' | translate) + mainService.asterisk }}</label>
            <button type="button" ngbDropdownToggle class="mb-2 mr-2 btn btn-outline-info" [class.error-border]="isInvalidSubmit && !form.value.pageId">
              {{ selectedPageName ? selectedPageName : ('TR_PAGE' | translate) + mainService.asterisk }}
            </button>
          </div>
          <div ngbDropdownMenu>
            <button type="button" class="dropdown-item" *ngFor="let item of pages" (click)="setSelectedPage(item.id, item.name)">
              {{ item.name }}
            </button>
          </div>
        </div>
        <div ngbDropdown>
          <div class="flex flex-column">
            <label>{{ ('TR_LANGUAGES' | translate) + mainService.asterisk }}</label>
            <button type="button" ngbDropdownToggle class="mb-2 mr-2 btn btn-outline-info" [class.error-border]="isInvalidSubmit && !form.value.languageId">
              {{ selectedLanguageName ? selectedLanguageName : ('TR_LANGUAGES' | translate) + mainService.asterisk }}
            </button>
          </div>
          <div ngbDropdownMenu>
            <button type="button" class="dropdown-item" *ngFor="let item of languages" (click)="setSelectedLanguage(item.languageId, item.name)">
              {{ item.name }}
            </button>
          </div>
        </div>
      </div>
      <div class="mt-2 mb-3 upload-block form-outline">
        <button type="button" class="mb-2 mr-2 btn-transition btn btn-outline-info upload-btn" (click)="avatar.click()">
          <i class="pe-7s-plus"></i>
          <p>{{ 'TR_UPLOADAVATAR' | translate }}</p>
        </button>
        <input #avatar hidden type="file" name="upload-avatar" (change)="handleFileInput($event.target.files)" />
        <div *ngIf="imagePath" [ngStyle]="{ 'background-image' : 'url(' + imagePath + ')' }" class="upload-avatar"></div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-6">
          <div class="position-relative form-group">
            <label for="name">{{ ('TR_NAME' | translate) + mainService.asterisk }}</label>
            <input
              name="name"
              [placeholder]="('TR_NAME' | translate) + mainService.asterisk"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.name"
              autocomplete="off"
              formControlName="name"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-6">
          <div class="position-relative form-group">
            <label for="buttonLink">{{ ('TR_BUTTON_LINK' | translate)}}</label>
            <input
              name="buttonLink"
              [placeholder]="('TR_BUTTON_LINK' | translate)"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.buttonLink"
              autocomplete="off"
              formControlName="buttonLink"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-6">
          <div class="position-relative form-group">
            <label for="buttonLinkUnauth">{{ ('TR_BUTTON_LINK_FOR_UNAUTHORISED_USERS' | translate)}}</label>
            <input
              name="buttonLink"
              [placeholder]="('TR_BUTTON_LINK_FOR_UNAUTHORISED_USERS' | translate)"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.buttonLinkUnauth"
              autocomplete="off"
              formControlName="buttonLinkUnauth"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-lg-4 col-md-6">
          <div class="position-relative form-group">
            <label for="name">{{ ('TR_SHORT_CONTENT' | translate)}}</label>
            <textarea
              name="shortContent"
              [placeholder]="('TR_SHORT_CONTENT' | translate)"
              type="text"
              class="form-control"
              [class.error-border]="isInvalidSubmit"
              autocomplete="off"
              formControlName="shortContent"
            ></textarea>
            <!-- [class.error-border]="isInvalidSubmit && !form.value.shortContent" -->
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6 mt-1 mb-2 checkboxes-block">
          <div class="position-relative form-check">
            <input name="showInSlider" id="showInSlider" type="checkbox" class="form-check-input" formControlName="showInSlider">
            <label for="showInSlider" class="form-check-label">{{ 'TR_SHOW_IN_SLIDER' | translate }}</label>
          </div>
        </div>
      </div>
      <hr>
      <label for="name">{{ ('TR_FULL_CONTENT' | translate) + mainService.asterisk }}</label>
      <div class="form-row">
        <div class="col-md-6 mt-1 mb-2 checkboxes-block">
          <div class="position-relative form-check">
            <input name="isShowRichTextEditor" id="isShowRichTextEditor" type="checkbox" class="form-check-input" (change)="onCheckboxChange($event)">
            <label for="isShowRichTextEditor" class="form-check-label">{{ 'TR_RICH_TEXT_EDITOR' | translate }}</label>
          </div>
        </div>
      </div>
      
      <div *ngIf="!isShowRichTextEditor" class="form-row">
        <div class="col-12">
          <div class="position-relative form-group">
            <textarea
              name="fullContent"
              [placeholder]="('TR_FULL_CONTENT' | translate) + mainService.asterisk"
              type="text"
              rows="8"
              class="form-control"
              [class.error-border]="isInvalidSubmit && !form.value.fullContent"
              autocomplete="off"
              formControlName="fullContent"
            ></textarea>
          </div>
        </div>
      </div>
      <div *ngIf="isShowRichTextEditor">
        <ckeditor class="editor" formControlName="fullContent" [class.error-editor]="isInvalidSubmit && !form.value.fullContent"></ckeditor>
      </div>
      <app-submit-button
        [spinnerId]="submitSpinnerId"
        [buttonName]="isCreateForm ? ('TR_CREATE' | translate) : ('TR_UPDATE' | translate)"
        [isInvalidSubmit]="isInvalidSubmit"
        [isFormValid]="form.valid"
      ></app-submit-button>
    </form>
  </div>
</div>